/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
/* eslint-disable max-len */
import Vue from 'vue';
import { MutationTree } from 'vuex';
import * as types from '@/store/types';
import {
  emptyWorkspace, emptyWorkspaceState, Member, Workspace, WorkspaceState,
} from './models';

export const mutations: MutationTree<WorkspaceState> = {
  [types.LOADING](state, loading: WorkspaceState['loading']) {
    state.loading = loading;
  },

  [types.MUTATE_USER_WORKSPACES](state, workspaces: Workspace[]) {
    state.workspaces = workspaces;
  },

  [types.MUTATE_FETCH_WORKSPACE](state, workspace: Workspace) {
    state.currentWorkspace = workspace;
  },

  [types.MUTATE_NEW_MEMBER](state, member: Member) {
    state.currentWorkspace.members = [...state.currentWorkspace.members, member];
  },

  [types.MUTATE_UPDATE_WORKSPACE](state, workspace: Workspace) {
    state.currentWorkspace = workspace;

    // update workspaces state
    const index = state.workspaces.findIndex((w) => w.id === workspace.id);
    if (index !== -1) {
      state.workspaces[index] = workspace;
    }
  },

  [types.MUTATE_REMOVE_MEMBER](state, { workspaceId, memberId }) {
    state.currentWorkspace.members = state.currentWorkspace.members.filter((m) => m.id !== memberId);
    state.workspaces = state.workspaces.filter((w) => w.id !== workspaceId);
  },

  [types.MUTATE_NEW_WORKSPACE](state, workspace: Workspace) {
    state.workspaces = [...state.workspaces, workspace];
  },

  [types.MUTATE_REMOVE_WORKSPACE](state, workspaceId: string) {
    const workspaceIndex = state.workspaces.findIndex((w) => w.id === workspaceId);
    if (workspaceIndex >= 0) {
      state.workspaces.splice(workspaceIndex, 1);
    }
    state.currentWorkspace = emptyWorkspace;
  },
};
